import React, {useEffect, useState} from "react";
import apiRequests from "../../Component/axios/config/config";
import WebLogo from "../../font & image/image/clansmartLogo.svg";
import toast from "react-hot-toast";
import Loading from "../../Component/Loading/Loading";
import {FaTrash} from "react-icons/fa";
import {MdArrowBack} from "react-icons/md";
import {useNavigate, useSearchParams} from "react-router-dom";
import logo from "../../font & image/image/clansmartLogo.svg";
import shoppingIcon from "../../font & image/image/shopping-bag-header.svg";

export default function EditBanners() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState({status: false, id: null});
    const [banners, setBanners] = useState([]);
    const [searchParams] = useSearchParams();
    const Type = searchParams.get("Type");


    function fetchBanners() {
        setLoading(true);

        apiRequests.get(`/api/banner/get-all`, {
            params: {
                is_slide: true,
                Type: Type
            }
        })
            .then((response) => {
                setBanners(response.data.data);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to get all banners");
                setBanners([]);
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        fetchBanners();
    }, []);


    function handleDeleteBanners(id) {

        setDeleteLoading({...deleteLoading, status: true, id: id});
        apiRequests.delete(`/api/banner/delete`, {
            data:
                {
                    id: id
                }
        })
            .then(() => {
                toast.success("Banner successfully deleted");
                fetchBanners();
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to delete banner");
            })
            .finally(() => setDeleteLoading({...deleteLoading, status: false, id: null}));
    }

    const sitePaths = [
        {link: "/", name: "home"},
        {link: "/groceryStore", name: "Grocery Store"},
        {link: "/orderFood", name: "Order Food"},
    ]

    return (
        <div className="grid gap-4 p-6">
            <div className="flex gap-4 items-center">
                <div className="text-3xl font-bold text-gray-800">
                    Edit Banners
                </div>
                <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <div className="flex gap-2">
                        <button
                            onClick={() => navigate(-1)}
                            className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
                        >
                            <MdArrowBack/>
                            Back
                        </button>
                    </div>
                </div>
            </div>

            {loading ? (
                <Loading/>
            ) : (
                banners.length > 0 ? (
                    banners.map((banner) => (
                        <>

                            {!banner?.is_automatic && (
                                <div className="relative mt-6 flex flex-col gap-8">
                                    <button
                                        disabled={deleteLoading.status}
                                        onClick={() => {
                                            handleDeleteBanners(banner._id)
                                        }}
                                        className={`absolute top-4 right-4 p-4 bg-red-200 rounded-full text-red-500 transition-all duration-200 hover:text-red-600 hover:bg-red-300  ${deleteLoading.status && "cursor-not-allowed"}`}
                                    >
                                        {deleteLoading.id === banner._id && deleteLoading.status ?
                                            <Loading/>
                                            :
                                            <FaTrash size={15}/>
                                        }
                                    </button>
                                    <div
                                        className={`flex flex-col gap-[5.5rem] sm:gap-4 border border-gray-400 py-4 rounded-xl`}>
                                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                                            <div className="flex gap-5 justify-center items-center">
                                                {/*<button*/}
                                                {/*    className="text-[32px] flex items-center justify-centers text-buttonColor-shade8"*/}
                                                {/*    onClick={() => setShowModalHeaterDesktop(true)}*/}
                                                {/*>*/}
                                                {/*    <div*/}
                                                {/*        className="flex flex-col gap-1.5 p-2 border border-black rounded-xl border-grey-shade9 sm:bg-transparent sm:border-transparent">*/}
                                                {/*        <IoMenuOutline/>*/}
                                                {/*    </div>*/}
                                                {/*</button>*/}
                                                <div className="md:hidden">
                                                    <img src={logo} alt="" className="min-w-full"/>
                                                </div>
                                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                                    Clans Smart
                                                </div>
                                                <div className="p-1 rounded-xl relative border border-black md:hidden">
                                                    <div>
                                                        <img src={shoppingIcon} alt="" className="min-h-4 min-w-4" width={35}
                                                             height={35}/>
                                                    </div>
                                                </div>
                                            </div>


                                            <div
                                                className={`w-fit flex justify-center gap-12 items-center md:gap-4 sm:justify-between"}`}>

                                                {sitePaths.map((item, index) => {

                                                    return (

                                                        <div key={index}
                                                             className={`${index === 0 ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}>
                                                            {item.name}
                                                        </div>
                                                    )
                                                })}

                                            </div>

                                        </nav>


                                        <div
                                            className="relative text-grey-shade1 flex justify-between w-full h-[414px] sm:w-[95%]  sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9">

                                            <img
                                                src={banner.image ? `${process.env.REACT_APP_API_URL}${banner.image.path}` : "none"}
                                                className="min-w-full"
                                                alt=""
                                            />

                                        </div>

                                    </div>

                                </div>
                            )}

                            {banner?.is_automatic && (
                                <div className="relative flex flex-col gap-8">
                                    <button
                                        disabled={deleteLoading.status}
                                        onClick={() => {
                                            handleDeleteBanners(banner._id)
                                        }}
                                        className={`absolute top-4 right-4 p-4 bg-red-200 rounded-full text-red-500 transition-all duration-200 hover:text-red-600 hover:bg-red-300  ${deleteLoading.status && "cursor-not-allowed"}`}
                                    >
                                        {deleteLoading.id === banner._id && deleteLoading.status ?
                                            <Loading/>
                                            :
                                            <FaTrash size={15}/>
                                        }
                                    </button>

                                    <div
                                        className={`flex flex-col gap-[5.5rem] rounded-xl sm:gap-4 border border-gray-400 py-4`}>
                                        <nav
                                            className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                                            <div className="flex gap-2 justify-center items-center">
                                                <div
                                                    className="text-[32px] flex items-center justify-centers text-buttonColor-shade8">
                                                    <div
                                                        className="flex flex-col gap-1.5 p-2 border-2 rounded-xl border-grey-shade9 bg-grey-shade9 sm:bg-transparent sm:border-transparent">
                                            <span
                                                className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                                        <span
                                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                                        <span
                                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                                    </div>
                                                </div>
                                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                                    <img src={WebLogo} alt="clansmart" className="w-24" height={42}
                                                         width={42}/>
                                                </div>
                                            </div>
                                            <div className="flex gap-2 justify-center items-center sm:hidden">
                                                <div className="flex gap-3 items-center relative">
                                                    <div
                                                        className="relative w-full rounded-xl border transition-colors duration-300 bg-white border-black text-black text-xl flex items-center px-8 py-2 gap-2"
                                                    >
                                                        <div className="flex justify-between items-center w-full">
                                                            En
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="w-fit px-4 py-2 text-center border-2 text-black text-xl bg-primary-shade6 border-primary-shade6 rounded-2xl"
                                                >
                                                    login / sign up
                                                </div>
                                            </div>
                                        </nav>

                                        <div
                                            style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}${banner?.cover?.path})`}}
                                            className={`relative text-grey-shade1 flex justify-between px-12 w-full h-[414px] sm:w-[95%] bg-cover bg-no-repeat sm:bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_20%,#FFD0B3_150%)] sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9`}>

                                            <div
                                                className="flex flex-col sm:items-center sm:justify-center py-24 gap-10 pl-24 w-[50%] sm:p-0 md:w-full md:pl-4 md:pt-32 sm:gap-5">
                                                <h3 className="flex justify-start w-full text-[48px] font-bold sm:text-xl">
                                                    {banner.header}
                                                </h3>
                                                <p className="w-full text-lg sm:text-[12px] sm:leading-4">
                                                    {banner.body}
                                                </p>
                                            </div>
                                            {banner.image &&
                                                <div
                                                    className="w-[40%] sm:w-[100%] flex items-center justify-center -mr-10">
                                                    <img
                                                        width={400}
                                                        height={580}
                                                        src={banner.image ? `${process.env.REACT_APP_API_URL}${banner.image.path}` : "none"}
                                                        alt=""
                                                    />
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    ))
                ) : (
                    <p className="w-full text-center text-xl text-gray-500 font-bold">
                        No banners found.
                    </p>
                )
            )}

        </div>
    );
}